// eslint-disable-next-line no-unused-vars
export default function preloaderWin (scene) {

	// TODO

}